import styles from "./Button.css";
import classNames from "classnames";
import PropTypes from "prop-types";

const LoyaltyBannerButton = ({ copy, url }) => (
  <a
    className={classNames("london2-button", styles.button, styles.joinButton)}
    href={url}
  >
    {copy}
  </a>
);

LoyaltyBannerButton.propTypes = {
  copy: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default LoyaltyBannerButton;
